import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class MembershipEnabledGuard  {
  constructor(private router : Router) {}

  async canActivate() {
    if(environment.becomingMemberDisabled) {
      void this.router.navigate(["/"]);
      return false;
    }

    return true;
  }
}
